"use client";
/**
 * Viewport-filling frame for /workspaces and /p/{slug}. On a scroll-canvas
 * profile the page is allowed to grow past the window so stacked bands
 * scroll with the document instead of sitting inside a locked 100vh cell.
 */
import type { ReactNode } from "react";
import { isActiveScrollCanvas } from "@/lib/display/profiles";

export function ScrollPageShell({
  title,
  children,
}: {
  title?: string;
  children: ReactNode;
}) {
  const scroll = isActiveScrollCanvas();
  return (
    <main
      className={
        scroll
          ? "legacy-light min-h-[calc(100dvh-var(--mpp-chrome-h))] w-full px-3 py-2 sm:px-4"
          : "legacy-light flex h-[calc(100dvh-var(--mpp-chrome-h))] w-full flex-col px-3 py-2 sm:px-4"
      }
    >
      {title ? (
        <h1 className="mb-2 shrink-0 text-xl font-semibold tracking-tight text-ink">{title}</h1>
      ) : null}
      <div className={scroll ? "w-full" : "min-h-0 flex-1"}>{children}</div>
    </main>
  );
}
